import React from 'react';
import { FeedbackQuestion } from '../../../types/feedback';

interface RadioQuestionProps {
  question: FeedbackQuestion;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const RadioQuestion: React.FC<RadioQuestionProps> = ({
  question,
  value,
  onChange,
  error
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="question-container">
      <label className="question-label">
        {question.question}
        {/* Removed required asterisk - all fields are now optional */}
      </label>
      
      <div className="radio-group">
        {question.options?.map((option, index) => (
          <label key={index} className="radio-option">
            <input
              type="radio"
              name={question.id}
              value={option}
              checked={value === option}
              onChange={handleChange}
              className="radio-input"
            />
            <span className="radio-label">{option}</span>
          </label>
        ))}
      </div>
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default RadioQuestion;
